import type {EnforceType} from '@wix/document-services-types'

export const ENFORCE_TYPES = {
    NONE: 'NONE',
    INNER: 'INNER',
    FULL: 'FULL',
    DONT_CARE: 'DONT_CARE',
    GENERATE_AND_ENFORCE: 'GENERATE_AND_ENFORCE'
} as const satisfies Record<string, EnforceType>
